export { default } from './monaco';
export { suffixToLanguage } from './tokenization/suffix-definitions';
